import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4a5843be&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4a5843be&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5843be",
  null
  
)

export default component.exports